type Point = {
  clientX: number;
  clientY: number;
};

export function rangeFromPoint(
  point: Point,
  doc: Document = window.document
): Range | null {
  if (doc.caretPositionFromPoint) {
    const pos = doc.caretPositionFromPoint(point.clientX, point.clientY);
    if (!pos) return null;

    const range = doc.createRange();
    range.setStart(pos.offsetNode, pos.offset);
    range.collapse(true);
    return range;
  }
  if (doc.caretRangeFromPoint) {
    return doc.caretRangeFromPoint(point.clientX, point.clientY);
  }

  throw new Error("No support for caret position from point");
}
